<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="components"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :refresh.sync="refresh"
      :sort="sort"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h2 class="page-heading mr-auto">Ингредиенты</h2>
      <button class="btn btn-primary mr-2" @click="openModal()" v-if="$root.checkPermission('web_recipes_edit')">Добавить ингредиент</button>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @sort-change="sortChange"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column sortable="keyword" label="Наименование" prop="name"/>
        <el-table-column label="Единица измерения" align="center">
          <template slot-scope="{row}">
            <span class="text-muted">{{ row.measure }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" width="220" v-if="$root.checkPermission('web_recipes_edit')">
          <template slot-scope="{row, $index}">
            <btn-action
              class="btn btn-sm btn-outline-light mr-2"
              @click="() => remove(row, $index)"
            >
              Удалить
            </btn-action>
            <button
              class="btn btn-sm btn-outline-light"
              @click="openModal(row)"
            >
              Редактировать
            </button>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import componentModal from '../../../components/recipes/component-modal.vue'
  import api from '@/api'

  export default {
    metaInfo: {title: 'Ингредиенты'},
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
        refresh: false,
        sort: null,
      }
    },
    methods: {
      openModal (component = null) {
        this.$root.showModal(componentModal, {
          component: component,
        }).then((data) => {
          if (data && data.refresh) {
            this.refresh = true
          }
        })
      },
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
      remove (component, index) {
        if (window.confirm('Удалить ингредиент?')) {
          return api.delete('components/' + component.id).then((data) => {
            this.data.data.splice(index, 1)
          })
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/recipes/ingredients.vue